export const projectsQuery = `*[_type == "project" && published == true] | order(sortOrder asc) {
  "slug": slug.current,
  title,
  client,
  industry,
  services,
  videos,
  cover,
  photography,
  color,
  tagline,
  challenge,
  direction,
  featured,
  hideOverview,
  sortOrder
}`;

export const projectBySlugQuery = `*[_type == "project" && published == true && slug.current == $slug][0] {
  "slug": slug.current,
  title,
  client,
  industry,
  services,
  videos,
  cover,
  photography,
  color,
  tagline,
  challenge,
  direction,
  featured,
  hideOverview,
  sortOrder
}`;

export const testimonialsQuery = `*[_type == "testimonial" && published == true] | order(sortOrder asc) {
  quote,
  author,
  sortOrder,
  featured
}`;
